const namespace = "support";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig ={
  name: "Support",
  namespace: "support",
  description: null,
  version: "0.1.0",
  icon: "mdi-school",
  parentRoute: "/support",
  defaultRoute: "overview",
  accentColor: "#FF8200",
  component: () => import( /* webpackChunkName: "tutorials-parent" */ "@/apps/tutorials/Application.vue"),
  childRoutes,
  navigation: [],
  settings: {
    city: "Sugar Land",
    state : "Texas",
    favoriteColor : "blue",
  },
  store : {
    dateFormat : {
      default: "YYYY-MM-DD",
      storageMode : sessionStorage,
    },
  },
}

export default AppConfig.merge(appConfig);
